import pick from 'lodash/pick';
import makeCloudFunctionRequest from '../makeCloudFunctionRequest';

export const sendQuickReplyMessage = async (ticket, message) => {
  const ticketFields = pick(ticket, ['platformDomain', 'platformTicketId', 'smbName', 'subject']);

  const newMessageObject = {
    ...ticketFields,
    conversationObjectId: ticket.ticketId,
    messageType: ticket.ticketType,
    simplrAccountObjectId: ticket.simplrAccountPtrId,
    simplrExpertObjectId: ticket.expertId,
    toChannel: ticket.fromChannel,
    fromChannel: ticket.simplrChannel,
    message,
  };

  await makeCloudFunctionRequest('sendMessageForExpert', newMessageObject);
};

export const clearStuckTickets = async (conversationId) => {
  const response = await makeCloudFunctionRequest('clearStuckTicketsInExpertQueue', {
    conversationObjectId: conversationId,
  });

  return response;
};

export { fetchLastCustomerMessage, fetchConversationMessages } from './queries/messageQueriesGraphQL';
